---
de:
  asset_comments:
    create_title: Neue Anlagenaussage erstellen
    overlap_current_month: Überlappende Aussage für aktuellen Monat im aktuellen Jahr
    overlap_current_quarter: Überlappende Aussage für aktuelles Quartal im aktuellen Jahr
    overlap_current_year: Überlappende Aussage für aktuelles Jahr
    title: Anlagenaussagen
